export { default } from './SupportText';